'use client';

import { faCalendarDays } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

interface BranchLaboratoryExamsActionProps {
  showsSchedules?: boolean;
  onSelectExams: () => void;
  onSeeSchedules: () => void;
}

const actionStyle = 'flex-1 min-w-0 text-base py-2';

export function BranchLaboratoryExamsAction({
  showsSchedules = false,
  onSelectExams,
  onSeeSchedules,
}: BranchLaboratoryExamsActionProps) {
  if (showsSchedules) {
    return (
      <Button
        startIcon={faCalendarDays}
        startIconSize="1x"
        startIconClassName="w-4 h-4 text-base"
        className={actionStyle}
        data-testid={DataTestIdEnum.BRANCH_LABORATORY_HEADER_SCHEDULES_BUTTON}
        data-analytics-event={AnalyticsEnum.LABORATORY_PROFILE_CLICK_SEE_SCHEDULES}
        onClick={onSeeSchedules}
      >
        Ver horários
      </Button>
    );
  }

  return (
    <Button
      startIcon={faCalendarDays}
      startIconSize="1x"
      startIconClassName="w-4 h-4 text-base"
      className={actionStyle}
      data-testid={DataTestIdEnum.BRANCH_LABORATORY_SELECT_EXAMS_BUTTON}
      data-analytics-event={AnalyticsEnum.LABORATORY_PROFILE_CLICK_SEE_EXAMS}
      onClick={onSelectExams}
    >
      Ver exames
    </Button>
  );
}
